import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const container = document.getElementById('root')!
const app = (
  <StrictMode>
    <App />
  </StrictMode>
)
// Yayın build'inde sayfalar ön-çizilir (scripts/prerender.mjs): kapta HTML varsa ona bağlanılır, sıfırdan
// çizilip içerik yanıp sönmez. Geliştirmede ve ön-çizimi olmayan adreste (blog yazısı) kap boştur.
if (container.hasChildNodes()) hydrateRoot(container, app)
else createRoot(container).render(app)
